import {
  Excalidraw,
  CaptureUpdateAction,
  exportToCanvas,
} from "@excalidraw/excalidraw";
import React ,{ useState, useEffect, useRef } from 'react'

import {
  Provider,
  useAtom,
  useAtomValue,
  useAtomWithInitialValue,
  appJotaiStore,
} from "./app-jotai";

import { MainMenuApp } from "./components/MainMenu";
import { AppWelcomeScreen } from "./components/AppWelcomeScreen";
import { OverwriteConfirmDialog } from "@excalidraw/excalidraw/components/OverwriteConfirm/OverwriteConfirm";
import {
  CommandPalette,
  DEFAULT_CATEGORIES,
} from "@excalidraw/excalidraw/components/CommandPalette/CommandPalette";

import { TopErrorBoundary } from "./components/TopErrorBoundary";
import { useAppLangCode } from "./app-language/language-state";
const ParentWindow = import.meta.env.VITE_PARENT_WINDOW;

export function ExcalidrawWrapper() {
  const [elements, setElements] = useState([]);
  // const [appState, setAppState] = useState({});
  const [langCode, setLangCode] = useAppLangCode();
  const [canvasUrl, setCanvasUrl] = useState("");
  const updateScene = () => {
    const sceneData = {
      elements:elements,
      // appState:appState,
      // elements2: [
      //   {
      //     type: "rectangle",
      //     version: 141,
      //     versionNonce: 361174001,
      //     isDeleted: false,
      //     id: "oDVXy8D6rom3H1-LLH2-f",
      //     fillStyle: "hachure",
      //     strokeWidth: 1,
      //     strokeStyle: "solid",
      //     roughness: 1,
      //     opacity: 100,
      //     angle: 0,
      //     x: 100.50390625,
      //     y: 93.67578125,
      //     strokeColor: "#c92a2a",
      //     backgroundColor: "transparent",
      //     width: 186.47265625,
      //     height: 141.9765625,
      //     seed: 1968410350,
      //     groupIds: [],
      //     boundElements: null,
      //     locked: false,
      //     link: null,
      //     updated: 1,
      //     roundness: {
      //       type: 3,
      //       value: 32,
      //     },
      //   },
      // ],
      // appState: {
      //   viewBackgroundColor: "#0ff",
      // },
      captureUpdate: CaptureUpdateAction.IMMEDIATELY,
    };
    excalidrawAPI.updateScene(sceneData);
  };

  // Listen for messages from parent ( First Load)
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== ParentWindow) return; // Security!
      if (event.data.type === "SET_ELEMENTS") {
        const els = event.data.payload.elements;
        // const as = event.data.payload.appState || {};
        setElements(els);
        // setAppState(as);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []); // No dependencies!

  // Send images to parent on generation when canvasurl change
 useEffect(() => {
    window.parent.postMessage(
      { 
        type: "ELEMENTS_IMAGE",
        payload: { image: canvasUrl,} 
      },
      ParentWindow,
    );
  }, [canvasUrl]);

  // Send state to parent on change
  const onChange = (els, as) => {
    if (els.length > 0 ){
      setElements(els);
    } 
    // setAppState(as);
    if (els.length > 0){
      window.parent.postMessage(
      { type: "UPDATE_ELEMENTS", payload: { elements: els,
        //  appState: as
        // appState: JSON.parse(JSON.stringify(as)), 
        } },
      ParentWindow,
    );
    }
  };

  // Listen for messages from parent ( Adding Elements)
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== ParentWindow) return; // Security!
      if (event.data.type === "SET_ELEMENTS") {
        const els = event.data.payload.elements;
        if (els.length > elements.length){
          const sceneData = {
            elements:els,
            captureUpdate: CaptureUpdateAction.IMMEDIATELY,
          };
          if (excalidrawAPI){
            excalidrawAPI.updateScene(sceneData);
          }
        }
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [elements]);

  const defaultStyle = {
    position:'fixed',
    right:'0%',
    top:"60%",
    zIndex: '100',
    backgroundColor: '#a78bfa',
    color: '#fff',
    fontWeight: 'bold',
    borderRadius: '50%',
    width: '25px',
    height: '25px',
    fontSize: '20px',
    cursor: 'pointer',
    marginRight: '5px',
    transition: 'background 0.2s, color 0.2s',
    padding:'0px'
  };

  const hoverStyle = {
    ...defaultStyle,
    backgroundColor: '#d946ef',
    color: '#fff'
  };

  const activeStyle = {
    ...defaultStyle,
    border: '2px solid #d946ef',
    backgroundColor: '#d946ef',
    color: '#fff'
  };

  const defaultImgStyle = {
    position:'fixed',
    right:'0px',
    top:"0px",
    zIndex: '100',
    border: 'none',
    color: '#df2525',
    cursor: 'pointer',
    marginRight: '0px',
    transition: 'background 0.2s, color 0.2s',
    padding:'0px'
  };

  const hoverImgStyle = {
    ...defaultImgStyle,
    backgroundColor: '#d946ef',
    color: '#fff'
  };

  const activeImgStyle = {
    ...defaultImgStyle,
    border: '2px solid #df2525',
    backgroundColor: '#d946ef',
    color: '#fff'
  };
  
  const [excalidrawAPI, setExcalidrawAPI] = useState(null);
  const [buttonStyle, setButtonStyle] = useState(defaultStyle);
  const [buttonImgStyle, setButtonImgStyle] = useState(defaultImgStyle);

  return (
    <div style={{ height: "100%", width:"100%"}}>
      <Excalidraw
        excalidrawAPI={(api) => setExcalidrawAPI(api)}
        initialData={{ elements }}
        onChange={onChange}
        langCode={langCode}
      >
        <MainMenuApp/>
        <button 
          style={buttonStyle}
          onClick={updateScene}
          onMouseEnter={() => setButtonStyle(hoverStyle)}
          onMouseLeave={() => setButtonStyle(defaultStyle)}
          onMouseDown={() => setButtonStyle(activeStyle)}
          onMouseUp={() => setButtonStyle(hoverStyle)}>
            ↺
        </button>
        <button style={buttonImgStyle}
          onMouseEnter={() => setButtonImgStyle(hoverImgStyle)}
          onMouseLeave={() => setButtonImgStyle(defaultImgStyle)}
          onMouseDown={() => setButtonImgStyle(activeImgStyle)}
          onMouseUp={() => setButtonImgStyle(hoverImgStyle)}
          onClick={async () => {
            if (!excalidrawAPI) {
              return
            }
            const elements = excalidrawAPI.getSceneElements();
            if (!elements || !elements.length) {
              return
            }
            const canvas = await exportToCanvas({
              elements,
              getDimensions: () => { return {width: 400, height: 400}}
            });
            setCanvasUrl(canvas.toDataURL());
          }}>
          X
        </button>
        <AppWelcomeScreen/>
        <OverwriteConfirmDialog>
          <OverwriteConfirmDialog.Actions.ExportToImage />
        </OverwriteConfirmDialog>
        <CommandPalette/>
      </Excalidraw>
    </div>
  );
}

const ExcalidrawApp = () => {
  return (
    <TopErrorBoundary>
      <Provider store={appJotaiStore}>
        <ExcalidrawWrapper />
      </Provider>
    </TopErrorBoundary>
  );
};

export default ExcalidrawApp;
